import { PressEventsType } from '@osmosis/backend/orm-db';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';
import PreviousEventItem from './PreviousEventItem';

type Props = {
  events: PressEventsType[];
};

/**
 * List of current events.
 */
const PreviousEventsList = (props: Props) => {
  const { events } = props;
  return (
    <Box cn="flex flex-wrap sm:gap-4 gap-8">
      {events.map((e) => (
        <Box key={e.eventId}>
          <PreviousEventItem event={e} />
        </Box>
      ))}
    </Box>
  );
};

export default PreviousEventsList;
